<template>
    <div>
        <vue-headful :title="'[Read Comments - '+commentCount+'] - AMOS365'" />

        <h4 class="page-header">
            My Read Comments ({{ commentCount }})
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="commentsTable" url="/comments/read" :columns="columns" :options="options">

                    <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                    </div>

                    <div slot="afterFilter" class="ml-2">
                        <button type="button" class="btn btn-sm btn-success" v-on:click="exportTable()" :disabled="exportingTable">
                            <template v-if="!exportingTable"><i class="fa fa-file-excel"></i> Export</template>
                            <template v-else><i class="fa fa-spinner fa-spin"></i> Exporting</template>
                        </button>
                    </div>

                    <template slot="id" slot-scope="props">
                        <button class="btn btn-xs btn-default" v-on:click="markUnread(props.row.id)">
                            <i :class="{'fas': true, 'fa-window-close': true, 'fa-spinner fa-spin': false}"></i> Mark Unread
                        </button>
                    </template>

                    <template slot="last_name" slot-scope="props">
                        <router-link :to="`/comments/view/${props.row.id}`">{{ props.row.last_name }}, {{ props.row.first_name }}</router-link>
                    </template>

                    <template slot="record_type" slot-scope="props">
                        <router-link :to="$root.getUrl(props.row)" :title="`View ${props.row.record_type}`">{{ $root.getRecordName(props.row) }}</router-link>
                    </template>

                    <template slot="created_at" slot-scope="props">
                        {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                    </template>
                    <template slot="read_at" slot-scope="props">
                        {{ props.row.read_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                    </template>

                    <template slot="child_row" slot-scope="props">
                        <span class="d-block py-2 px-2">{{ props.row.comment_details }}</span>
                    </template>
                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                commentCount: null,
                exportingTable: false,
                read_comments: {},
                columns: ['id', 'last_name', 'record_type', 'created_at', 'read_at'],
                options: {
                    headings: {
                        id: 'Mark Unread',
                        last_name: 'User Who Commented',
                        record_type: 'Commented On',
                        created_at: 'Comment Timestamp',
                        read_at: 'When You Read It',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'comments.created_at',
                    },
                    texts:{
                        filterPlaceholder:"Search Comments",
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        if(this.commentCount === null)
                        {
                            //Set the count
                            this.commentCount = response.data.count;
                        }
                        //this.$emit('commentListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {
            markUnread(comment_id){
                //Send it
                //this.read_comments[i] = true;

                // Test comment1
                this.$http.post('/comments/read/'+comment_id)
                    .then(response => {
                        //Set the data
                        this.$refs.commentsTable.refresh();
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Send it
                        //delete this.read_comments[i];
                    });
            },
        },

        mounted() {
            //Focus on the SEarch Input
            this.$refs.commentsTable.$refs.genericFilter.focus();
        }
    }
</script>
